import get from 'lodash.get';

const getPartnerSubmitUserActionUrl = (rootState) =>
  get(rootState, 'user.partnerData.properties.submitUserActionUrl', null);

export default getPartnerSubmitUserActionUrl;
